import {
  CLEAN_SIGNATURE_FILES
} from "../types";


const cleanSignatureFiles= () => {
  return({type: CLEAN_SIGNATURE_FILES});
};
export default cleanSignatureFiles;